import React from "react";
import { Link, useParams } from "react-router-dom";

const tabs = [
  { label: "Speed Warmup", path: "warmup-routine" },
  { label: "Speed Workout", path: "speed-workout" },
  { label: "Strength Workout", path: "strength-workout" },
  { label: "Race Model", path: "speed-performance" },
  { label: "Speed Charts", path: "speed-charts" },
  { label: "Runrocket Results", path: "runrocket-result" },
  { label: "Messages", path: "message" },
];

export const AthleteTabMenu = ({ active }) => {
  const { athlete_id } = useParams();

  return (
    <div className="bg-white w-full px-5 md:px-8 xl:px-16 mt-4">
        <div className="flex flex-nowrap gap-8 pt-4 border-t border-tblBorder overflow-x-auto show-scrollbar">
          {tabs.map((tab) => {
            const isActive = tab.path === active;
            return (
              <Link
                key={tab.path}
                to={`/administrator/athlete/${tab.path}/${athlete_id}`}
                className={`flex-shrink-0 pb-3 text-xs md:text-sm whitespace-nowrap font-inter font-medium leading-none border-b-2 border-transparent transition hover:text-dark hover:border-dark ${
                  isActive ? "!border-darkYellow text-dark" : "text-slate100"
                }`}
              >
                {tab.label}
              </Link>
            );
          })}
        </div>
    </div>
  );
};
